export enum GroupOrigin {
    Marketing = 1,
    Vendas = 2,
    Parceiro = 3,
    Indicacao = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/GroupOrigin.ts